import React from 'react';
import { connect } from "react-redux";
import { Route, Link, BrowserRouter as Router, Switch } from 'react-router-dom';
import { deleteUnit } from "./../../actions";
import { textShort } from '../../common';
import StatFileLink from '../StatFileLink';
import DlUnitSingleNav from './DlUnitSingleNav';

const mapStateToProps = (state) => ({
  dlUnitMaxPerPage: state.dlUnitLi.dlUnitMaxPerPage, 
  dlUnitCount: state.dlUnitLi.dlUnitCount, 
  dlUnitPage: state.dlUnitLi.dlUnitPage
});

const mapDispatchToProps = (dispatch) => ({
  deleteUnit: (payload) => dispatch(deleteUnit(payload))
});

const DlUnitEl = ({ item, id, ind, deleteUnit, dispType }) => {
  const itemFValGet = (fNam) => {
    let fVal = '';
    if (item.hasOwnProperty('fVals') && item.fVals.hasOwnProperty(fNam)) {
      fVal = item.fVals[fNam];      
    }
    return fVal;
  }

  const f700a = itemFValGet('700_a');
  const f700b = itemFValGet('700_b');
  const f200a = itemFValGet('200_a');
  const f210a = itemFValGet('210_a');
  const f210d = itemFValGet('210_d');
  const f300a = itemFValGet('300_a');
  const autor = ( f700b!='' ? f700a + ', ' + f700b : f700a );
  const naslov = f200a;
  const datum = f210d;
  const grad = f210a;
  const napomena = f300a;

  console.log('f300a', f300a);

  const elNav = dispType == 'adm' ? <span>
      <DlUnitSingleNav item={ item } />
      {/* <Link to={{ pathname: '/admin-dashboard/dl-unit-edit/' + item.id, state: { ind, item } }} >
        <span style={{marginLeft: '0%'}}>polja</span>
      </Link>          */}
      <span onClick={() => window.confirm('Obrisati stavku?') ? deleteUnit(id) : ''} style={{marginLeft: '5%', cursor: 'pointer', color: 'darkgrey'}}>obriši</span>

    </span> : null;

  const pdfLinkP = ( item.hasOwnProperty('pdf') && item.pdf!='' ? <StatFileLink fold={ item.pdf.fold } fNam={ item.pdf.nam } nam={ 'pdf' } /> : null );

  return (
    <div style={{ float: 'left', marginTop: '1em', width: '100%', lineHeight: '1.5em' }}>
      { elNav }          
      <br />
Autor: { textShort(autor) }<br />
Naslov: {naslov}<br />
Datum: {datum}<br />
Grad: {grad}<br />
Napomena: {napomena}<br />
{pdfLinkP}<br />
    </div>
  );

}

export default connect(mapStateToProps, mapDispatchToProps)(DlUnitEl);
